//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { CfdMatchResult } from './models/cfd-match-result.model';
import { GetDescriptionRequest } from './models/get-description-request.model';
import { GetRuleExpressionsInHierarchyRequestDto } from './models/get-rule-expressions-in-hierarchy-request-dto.model';
import { GetWinningRuleSetRequest } from './models/get-winning-rule-set-request.model';
import { GroupedWinningRuleset } from './models/grouped-winning-ruleset.model';
import { WinningMatchResult } from './models/winning-match-result.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class WinningRuleSetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getWinningRuleSet(request: GetWinningRuleSetRequest): Observable<WinningMatchResult> {
        let url_ = this.baseUrl + "/AyaNova/compliance/winning-ruleset/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWinningRuleSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWinningRuleSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WinningMatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WinningMatchResult>;
        }));
    }

    protected processGetWinningRuleSet(response: HttpResponseBase): Observable<WinningMatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WinningMatchResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDescription(request: GetDescriptionRequest): Observable<CfdMatchResult> {
        let url_ = this.baseUrl + "/AyaNova/compliance/winning-ruleset/description";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CfdMatchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CfdMatchResult>;
        }));
    }

    protected processGetDescription(response: HttpResponseBase): Observable<CfdMatchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CfdMatchResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getGroupedWinningRuleset(request: GetRuleExpressionsInHierarchyRequestDto): Observable<GroupedWinningRuleset> {
        let url_ = this.baseUrl + "/AyaNova/compliance/winning-ruleset/grouped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupedWinningRuleset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupedWinningRuleset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupedWinningRuleset>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupedWinningRuleset>;
        }));
    }

    protected processGetGroupedWinningRuleset(response: HttpResponseBase): Observable<GroupedWinningRuleset> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupedWinningRuleset;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}